import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import { useStudentDashboard } from '@/data/context/StudentDashboardContext';
import { coursePathsQueryKeys } from '@/data/services/querykeys';

export default function useActiveCourse() {
  const { slugCourseName = '' } = useParams();
  const { activeCourseProgress, isLoading: isLoadingCourseProgress } =
    useStudentDashboard();

  const { data: coursePath, isInitialLoading } = useQuery({
    ...coursePathsQueryKeys.get(slugCourseName),
    enabled:
      !isLoadingCourseProgress && !activeCourseProgress && !!slugCourseName,
    staleTime: REQUEST_STALE_TIME_IN_MS,
  });

  return {
    course: activeCourseProgress?.coursePath.course ?? coursePath?.course,
    isLoading: isLoadingCourseProgress || isInitialLoading,
  };
}
